import React, { useCallback, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ExportButton } from '@/core/components/ExportButton/ExportButton';
import { AnnotationHistoryModal } from '../AnnotationHistoryModal/AnnotationHistoryModal';
import './ClassifySubMenu.scss';

const BdsIcon = 'bds-icon' as any;

export const ClassifySubMenu: React.FC = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const dispatch = useCallback((eventName: string, detail?: unknown) => {
    window.dispatchEvent(new CustomEvent(eventName, { detail }));
  }, []);

  const handleHistoryClick = () => {
    dispatch('mfe-classify-history-click');
  };

  useEffect(() => {
    const handleOpen = () => setIsModalOpen(true);
    window.addEventListener('mfe-classify-history-click', handleOpen);
    
    return () => window.removeEventListener('mfe-classify-history-click', handleOpen);
  }, []);

  return (
    <div className="classify-submenu">
      <ExportButton />

      <button 
        type="button" 
        className="classify-submenu__history-btn" 
        onClick={handleHistoryClick}
        aria-label={t('sortBy.submenu.history')}
      >
        <BdsIcon name="restore" theme="outline" />
        <span>{t('sortBy.submenu.button-history')}</span>
      </button>

      <AnnotationHistoryModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </div>
  );
};